import {
  RelatorioDespesaItem,
  RelatorioDespesaFields,
} from "features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text, Link } from "@react-pdf/renderer";
import moment from "moment";
import { getContaCategoriaText } from "./../util/getContaCategoriaText";

function useRelatorioDespesaPdfColumns(
  includedFields: RelatorioDespesaFields[] = [
    "dataVencimento",
    "dataPagamento",
    "descricao",
    "documento",
    "pessoaNome",
    "valor",
  ]
): PDFTableColumn<RelatorioDespesaItem>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<RelatorioDespesaItem>[] = [];

    if (includedFields.includes("dataVencimento")) {
      columns.push({
        title: "Vencimento",
        flexGrow: 0.6,
        render: (original) => (
          <View>
            <Text>{moment(original.dataVencimento).format("DD/MM/YYYY")}</Text>
          </View>
        ),
      });
    }

    if (includedFields.includes("dataPagamento")) {
      columns.push({
        title: "Pagamento",
        flexGrow: 0.6,
        render: (original) => (
          <View>
            <Text>
              {original.dataPagamento
                ? moment(original.dataPagamento).format("DD/MM/YYYY")
                : "--"}
            </Text>
          </View>
        ),
      });
    }

    if (includedFields.includes("pessoaNome")) {
      columns.push({
        title: "Favorecido",
        flex: 0.5,
        render: (original) => (
          <View>
            <Text>{original.pessoa.nome}</Text>
          </View>
        ),
      });
    }

    if (includedFields.includes("descricao")) {
      columns.push({
        title: "Descrição",
        render: (original) => (
          <View>
            <Text>{original.descricao}</Text>
          </View>
        ),
      });
    }

    if (includedFields.includes("documento")) {
      columns.push({
        title: "Documentos",
        flexGrow: 0.6,
        render: (original) => (
          <View>
            {original.anexos.map((item, index) => (
              <>
                <Link src={item.referencia} key={index}>
                  {item.tipo ? item.tipo : "Arquivo"}
                </Link>
                <br />
              </>
            ))}
          </View>
        ),
      });
    }

    if (includedFields.includes("contaCategoria")) {
      columns.push({
        title: "Categoria",
        flexGrow: 0.5,
        render: (original) => (
          <View>
            <Text>{getContaCategoriaText(original.contasCategorias)}</Text>
          </View>
        ),
      });
    }

    if (includedFields.includes("valor")) {
      columns.push({
        title: "Valor",
        flexGrow: 0.6,
        textAlign: "right",
        render: (original) => (
          <View>
            <Text>{formatMoney(original.valor)}</Text>
          </View>
        ),
      });
    }

    return columns;
  }, [includedFields]);
}

export default useRelatorioDespesaPdfColumns;
